import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export interface DailyExtractionRate {
  date: string;
  count: number;
}

export function useExtractionRate() {
  const query = useQuery({
    queryKey: ["extraction-rate"],
    queryFn: async (): Promise<DailyExtractionRate[]> => {
      const sevenDaysAgo = new Date(
        Date.now() - 7 * 24 * 60 * 60 * 1000
      ).toISOString();

      const { data, error } = await supabase
        .from("memories")
        .select("metadata_extracted_at")
        .not("metadata_extracted_at", "is", null)
        .gte("metadata_extracted_at", sevenDaysAgo);

      if (error) throw error;

      const counts = new Map<string, number>();
      for (const row of data ?? []) {
        if (!row.metadata_extracted_at) continue;
        const dateStr = row.metadata_extracted_at.slice(0, 10);
        counts.set(dateStr, (counts.get(dateStr) ?? 0) + 1);
      }

      const result: DailyExtractionRate[] = [];
      for (let i = 6; i >= 0; i--) {
        const d = new Date(Date.now() - i * 24 * 60 * 60 * 1000);
        const dateStr = d.toISOString().slice(0, 10);
        result.push({ date: dateStr, count: counts.get(dateStr) ?? 0 });
      }
      return result;
    },
    staleTime: 5 * 60 * 1000,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error as Error | null,
    refetch: query.refetch,
  };
}
